import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

interface DataSubjectDetailsContextValue {
  segment: string | number;
  setSegment: (segment: string | number) => void;
  total: number;
  setTotal: (total: number) => void;
  commentsTotal: number;
  setCommentsTotal: (total: number) => void;
}

const DataSubjectDetailsContext = createContext<
  DataSubjectDetailsContextValue | undefined
>(undefined);

export const useDataSubjectDetailsContext = () => {
  const context = useContext(DataSubjectDetailsContext);

  if (context === undefined) {
    throw new Error(
      'useDataSubjectDetailsContext must be used within a DataSubjectDetailsContextProvider'
    );
  }

  return context;
};

export const DataSubjectDetailsContextProvider: FC<PropsWithChildren> = (
  props
) => {
  const { children } = props;
  const [segment, setSegment] = useState<string | number>('history');
  const [total, setTotal] = useState(0);
  const [commentsTotal, setCommentsTotal] = useState(0);

  const value: DataSubjectDetailsContextValue = useMemo(
    () => ({
      segment,
      setSegment,
      total,
      setTotal,
      commentsTotal,
      setCommentsTotal,
    }),
    [segment, setSegment, total, setTotal, commentsTotal, setCommentsTotal]
  );

  return (
    <DataSubjectDetailsContext.Provider value={value}>
      {children}
    </DataSubjectDetailsContext.Provider>
  );
};
